/**
 * A15 — Liasse Fiscale: shared HTTP helpers for section API calls.
 */
import { API_BASE } from '../../../shared/utils/apiConfig';

export const apiCall = async (endpoint, method = 'GET', data = null) => {
  const base = (API_BASE || 'http://localhost:5001/api').replace(/\/$/, '');
  const options = {
    method,
    headers: { 'Content-Type': 'application/json' },
  };
  if (data) options.body = JSON.stringify(data);

  const response = await fetch(`${base}${endpoint}`, options);
  const result = await response.json();
  if (!response.ok) throw new Error(result.error || `HTTP error! status: ${response.status}`);
  return result;
};

export const blobPost = async (endpoint, data) => {
  const base = (API_BASE || 'http://localhost:5001/api').replace(/\/$/, '');
  const response = await fetch(`${base}${endpoint}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    let message = 'Export failed';
    try {
      const err = await response.json();
      message = err.error || message;
    } catch {
      // response may not be JSON (e.g. binary error body)
    }
    throw new Error(message);
  }
  return response;
};
